import { IconProps } from '@/assets/types/icon'

const YouTubeLogo = ({ className, ...props }: IconProps) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M32 16C32 7.16344 24.8366 0 16 0C7.16345 0 0 7.16344 0 16C0 24.8366 7.16345 32 16 32C24.8366 32 32 24.8366 32 16Z"
        fill="#7D7D7D"
      />
      <path
        d="M26.0749 12.6845C25.949 11.4691 25.6781 10.1255 24.6808 9.41948C23.9084 8.87194 22.8931 8.8517 21.9454 8.85282C19.9418 8.85282 17.9372 8.8562 15.9337 8.85733C14.0066 8.85958 12.0796 8.8607 10.1525 8.86295C9.3475 8.86295 8.56498 8.80111 7.81731 9.14964C7.17533 9.44871 6.67277 10.0176 6.37033 10.6506C5.95096 11.5309 5.86327 12.5282 5.81268 13.5018C5.71936 15.2749 5.72948 17.0524 5.84079 18.8243C5.92286 20.1172 6.13085 21.5462 7.13036 22.3704C8.01632 23.1 9.26654 23.136 10.4156 23.1371C14.0628 23.1405 17.7112 23.1439 21.3596 23.1461C21.8273 23.1473 22.3153 23.1383 22.792 23.0865C23.7296 22.9854 24.6234 22.7166 25.2261 22.0218C25.8343 21.3214 25.9906 20.3466 26.0828 19.4236C26.3077 17.1839 26.3054 14.923 26.0749 12.6845ZM13.8245 19.1391V12.8599L19.2616 15.9989L13.8245 19.1391Z"
        fill="white"
      />
    </svg>
  )
}

export default YouTubeLogo
